/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ImportBusinessBodyItem } from './ImportBusinessBodyItem';
import {
    ImportBusinessBodyItemFromJSON,
    ImportBusinessBodyItemFromJSONTyped,
    ImportBusinessBodyItemToJSON,
    ImportBusinessBodyItemToJSONTyped,
} from './ImportBusinessBodyItem';

/**
 * 
 * @export
 * @interface ImportBusinessBody
 */
export interface ImportBusinessBody {
    /**
     * 
     * @type {Array<ImportBusinessBodyItem>}
     * @memberof ImportBusinessBody
     */
    data?: Array<ImportBusinessBodyItem>;
}

/**
 * Check if a given object implements the ImportBusinessBody interface.
 */
export function instanceOfImportBusinessBody(value: object): value is ImportBusinessBody {
    return true;
}

export function ImportBusinessBodyFromJSON(json: any): ImportBusinessBody {
    return ImportBusinessBodyFromJSONTyped(json, false);
}

export function ImportBusinessBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): ImportBusinessBody {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(ImportBusinessBodyItemFromJSON)),
    };
}

export function ImportBusinessBodyToJSON(json: any): ImportBusinessBody {
    return ImportBusinessBodyToJSONTyped(json, false);
}

export function ImportBusinessBodyToJSONTyped(value?: ImportBusinessBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(ImportBusinessBodyItemToJSON)),
    };
}

